import { swymLoaded } from '../helpers';
class WishlistService {
  fetchList(wishlistId) {
    return new Promise((resolve, reject) => {
      swymLoaded().then(() => {
        _swat.fetchListDetails(
          { lid: wishlistId },
          function(list) {
            resolve(list);
          },
          function(xhrObj) {
            reject(xhrObj);
          }
        );
      });
    });
  }

  getAllWishlists() {
    return new Promise((resolve, reject) => {
      // Needed on this function as _swat lazy loaded and could be called before loaded
      swymLoaded().then(() => {
        _swat.fetchLists({
          callbackFn: function(lists) {
            resolve(lists);
          },
          errorFn: function(xhrObj) {
            reject(xhrObj);
          },
        });
      });
    });
  }
  deleteWishlist(wishlistId) {
    return new Promise((resolve, reject) => {
      _swat.deleteList(
        wishlistId,
        function(deletedListObj) {
          resolve(deletedListObj);
        },
        function(xhrObject) {
          reject(xhrObject);
        }
      );
    });
  }

  removeItemFromWishlist(wishlistId, item) {
    const listItemMap = {
      epi: item.variantId,
      empi: item.productId,
      du: item.url,
    };

    return new Promise((resolve, reject) => {
      _swat.deleteFromList(
        wishlistId,
        listItemMap,
        function(deletedListItem) {
          document.dispatchEvent(new Event('product-removed-to-wishlist'));
          resolve(deletedListItem);
        },
        function(xhrObj) {
          reject(xhrObj);
        }
      );
    });
  }

  updateList(listUpdateMap) {
    return new Promise((resolve, reject) => {
      _swat.updateList(
        listUpdateMap,
        function(updateListObj) {
          resolve(updateListObj);
        },
        function(xhrObject) {
          reject(xhrObject);
        }
      );
    });
  }

  sendListViaEmail(objectMap) {
    return new Promise((resolve, reject) => {
      _swat.sendListViaEmail(
        {
          toEmailId: objectMap.recipientEmail,
          fromName: objectMap.senderName,
          note: objectMap.message,
          lid: objectMap.wishlistId, // null when multiple list is not enabled
        },
        function() {
          resolve();
        },
        function() {
          reject('Error sending wishlist share email.');
        }
      );
    });
  }

  getWishlistShareUrl(wishlistId) {
    return new Promise((resolve, reject) => {
      _swat.generateSharedListURL(
        wishlistId,
        function(data) {
          resolve(data);
        },
        function() {
          reject('Error generating wishlist share url');
        }
      );
    });
  }

  shareViaSocial(socialPlatform, wishlistDetails) {
    return new Promise((resolve, reject) => {
      // _swat.retailerSettings.Wishlist.SharingModes
      const platformObject = _swat.retailerSettings.Wishlist.SharingModes.find(
        sharingMode => sharingMode.type === socialPlatform
      );
      const { wishlistId, senderName, message } = wishlistDetails;
      const shareMessage = message && message.length ? message : '';

      _swat.shareListSocial(
        wishlistId,
        senderName,
        platformObject.url,
        platformObject.type,
        shareMessage,
        function(data) {
          reject(data);
        }
      );
      resolve();
    });
  }
}

export default WishlistService;
